module.exports = __webpack_public_path__ + "img/eight5Green.a30d98d6.jpg";